function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_8994",
  "data-name": "Path 8994",
  d: "M8029.072,8722.816a9,9,0,1,0,9,9A9.01,9.01,0,0,0,8029.072,8722.816Zm2.369,5.711,1.414-1.414a.65.65,0,0,1,.92.92l-1.414,1.414a.65.65,0,0,1-.92-.92Zm-3.019-2.711a.651.651,0,0,1,1.3,0v2a.651.651,0,0,1-1.3,0Zm-4.052,1.3a.651.651,0,0,1,.92,0l1.414,1.414a.65.65,0,0,1-.92.92l-1.414-1.414A.65.65,0,0,1,8024.37,8727.113Zm-1.948,4.7a.65.65,0,0,1,.65-.65h2a.65.65,0,1,1,0,1.3h-2A.65.65,0,0,1,8022.422,8731.816Zm4.283,3.288-1.415,1.414a.65.65,0,0,1-.92-.92l1.415-1.414a.65.65,0,0,1,.92.92Zm3.019,2.712a.651.651,0,0,1-1.3,0v-2a.651.651,0,0,1,1.3,0Zm-.651-4a2,2,0,1,1,2-2A2,2,0,0,1,8029.072,8733.816Zm4.7,2.7a.651.651,0,0,1-.92,0l-1.415-1.414a.65.65,0,0,1,.92-.92l1.415,1.414A.652.652,0,0,1,8033.774,8736.519Zm1.3-4.052h-2a.65.65,0,0,1,0-1.3h2a.65.65,0,1,1,0,1.3Z",
  transform: "translate(-8020.072 -8722.816)",
  fill: "#fff"
});

var SvgLiveCasino = function SvgLiveCasino(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLiveCasino, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/live-casino.dd5b6143.svg";
export { ForwardRef as ReactComponent };